module.exports = __webpack_public_path__ + "static/media/desk.4460ea30.svg";